module.exports = __webpack_public_path__ + "static/img/21.222c8265.png";